<template>
    <label class="search-field "> 
        <span class="search-field__label">{{ title }}</span>
        <input
            v-model="value"
            class="search-field__input"
            :type="type"
            @input="$emit('input', $event.target.value)"
            @change="onChangeHandler"
        >
    </label>
</template>

<script>
const SearchField = {
    props: {
        value: {
            type: String
        },
        type: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    methods: {
        onChangeHandler() {
            this.$emit('update:value', this.value)
        }
    }
}

export default SearchField;
</script>

<style scoped >
    
.search-field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 38px;
}

.search-field__label {
    flex: 0 0 120px;
    width: 100%;
    min-width: 120px;
    padding-right: 10px;
    font-size: 16px;
    line-height: 22px;
    color: #000;
    text-align: left;
}

.search-field__input {
    display: inline-flex;
    padding: 0 20px;
    width: 100%;
    height: 41px;
    border: 1px solid #E0E0E0;
    background-color: #F2F2F2;
}

</style>

